import React, { useCallback, useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import ReactPlayer from "react-player";
import moment from "moment";
// import CommentBox from "../common/ComentBox";
import { useSelector } from "react-redux";
import { getGoal, getClubGoal } from "../../../../api/getGoal";
import { toast } from "react-toastify";
import VoteComponent from "../../../users/voteComponent/Index";
// import ComentBox from "../../../users/common/ComentBoxNew";
import ComentBox from "../../../users/common/CommentBoxCommon";
import ShareComponent from "../../../users/common/share/Index";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "925px",
  width: "90dvw",
  height: "90dvh",
  bgcolor: "#242743",
  border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",

  //   p: 4,
};

const headStype = {
  padding: "15px 15px",
  borderBottom: "1px solid #414466",
  display: "flex",
  alignItems: "center",
};

const contentStyle = {
  padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

export default function GoalModal({
  open,
  setOpen,
  goalId,
  count,
  setCount,
  data,
}) {
  const [voteState, setVoteState] = useState(0);
  const [loading, setloading] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const [goal, setGoal] = useState(data);
  const shareUrl = useRef(window.location.href);

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {loading ? (
          <Box>
            <CircularProgress enableTrackSlot size="25px" />
          </Box>
        ) : goal ? (
          <>
            <Box sx={headStype}>
              <IconButton
                onClick={() => {
                  setOpen(false);
                }}
              >
                <ArrowBackIcon sx={{ color: "white" }} />
              </IconButton>

              <Box sx={{ flexGrow: "1", textAlign: "center" }}>
                <Typography
                  component={"span"}
                  sx={{
                    fontSize: { sm: "22px", lg: "22px", xs: "16px" },
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {goal?.title}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ borderBottom: "1px solid #414466" }}></Box>
            <Box sx={contentStyle}>
              <Box
                sx={{
                  width: "100%",
                  height: "70%",
                  maxWidth: "700px",
                  maxHeight: "320px",
                  alignSelf: "center",
                }}
              >
                <ReactPlayer
                  url={goal.video_link}
                  controls={true}
                  width="100%"
                  height="100%"
                  config={{
                    file: {
                      attributes: {
                        poster: goal.thumbnail,
                      },
                    },
                  }}
                />
              </Box>

              <Box sx={{ marginTop: "20px", flexGrow: "1" }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: "10px", md: "20px" },
                    alignItems: "center",
                  }}
                >
                  <VoteComponent
                    id={goal.id}
                    vote={goal.hasVoted}
                    count={count}
                    setCount={setCount}
                    type={"league"}
                    // setData={setData}
                  />

                  {loading ? (
                    <CircularProgress enableTrackSlot size="25px" />
                  ) : (
                    <ComentBox
                      count={goal.commentsCount}
                      id={goal.id}
                      api={`leagues/getAllComments/${goal.id}`}
                    />
                  )}

                  <ShareComponent
                    data={goal}
                    title={goal?.title}
                    shareUrl={`${shareUrl.current}?share=${goal.id}`}
                  />
                </Box>

                <Typography
                  component="p"
                  sx={{
                    color: "white",
                    fontSize: { sm: "18px", xs: "16px", md: "20px" },
                  }}
                >
                  <strong>Video Category: </strong>
                  {goal?.clubCategory_assoc?.name}
                </Typography>
                {goal?.clubSubCategory_assoc ? (
                  <Typography
                    component="p"
                    sx={{
                      color: "white",
                      fontSize: { sm: "18px", xs: "16px", md: "20px" },
                    }}
                  >
                    <strong>Video Category: </strong>
                    {goal?.clubSubCategory_assoc?.name}
                  </Typography>
                ) : null}
                <Typography
                  component="p"
                  sx={{
                    color: "white",
                    fontSize: { sm: "18px", xs: "16px", md: "20px" },
                  }}
                >
                  <strong>Video From (UK/International): </strong>
                  {goal?.from_uk ? "England" : "International"}
                </Typography>
                <Typography
                  component="p"
                  sx={{
                    color: "white",
                    fontSize: { sm: "18px", xs: "16px", md: "20px" },
                  }}
                >
                  <strong>Created By: </strong>
                  {goal?.clubGoalOwner?.fullName}
                </Typography>
                <Typography
                  component="p"
                  sx={{
                    color: "white",
                    fontSize: { sm: "18px", xs: "16px", md: "20px" },
                  }}
                >
                  <strong>City/Town: </strong>
                  {goal?.region}
                </Typography>
                <Typography
                  component="p"
                  sx={{
                    color: "white",
                    fontSize: { sm: "18px", xs: "16px", md: "20px" },
                  }}
                >
                  <strong>goal scorer: </strong>
                  {goal?.goal_scorer}
                </Typography>
                <Typography
                  component="p"
                  sx={{
                    color: "white",
                    fontSize: { sm: "18px", xs: "16px", md: "20px" },
                  }}
                >
                  <strong>Created On: </strong>
                  {moment(goal?.createdAt).format("MM/DD/YYYY")}
                </Typography>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box sx={headStype}>
              <IconButton
                onClick={() => {
                  setOpen(false);
                }}
              >
                <ArrowBackIcon sx={{ color: "white" }} />
              </IconButton>

              <Box sx={{ flexGrow: "1", textAlign: "center" }}>
                <Typography
                  component={"span"}
                  sx={{
                    fontSize: { sm: "22px", lg: "22px", xs: "16px" },
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Error
                </Typography>
              </Box>
            </Box>
            <Box sx={contentStyle}>
              <Typography
                component="p"
                sx={{
                  color: "white",
                  fontSize: { sm: "18px", xs: "16px", md: "20px" },
                }}
              >
                Unable to load goal data.
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
